var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"google-map-container"},[_c('div',{ref:"googleMapDiv",staticClass:"google-map ml-n3 mr-n3",style:({ height: _vm.height }),attrs:{"id":"google-map"}}),_c('MapZoomSlider',{on:{"zoom-to-user":_vm.zoomToUser},model:{value:(_vm.zoom),callback:function ($$v) {_vm.zoom=$$v},expression:"zoom"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }